<script>
import CustomersApi from "@/services/customers-api";
import PendingValidationOrdersList from "@/components/pendingValidationOrderslist"

export default {

  computed: {
    role() {
      return this.$cookies.get('userr');
    },
  },

  mounted(){

    this.isAdmin=!this.role && this.role != 0;
      this.privileges= true;
      this.isAdmin= true; 

    if(this.role==1 || this.role==2){
      this.getCustomers()
    }
  },

  components: {PendingValidationOrdersList },
  data() {
    return {
      selected:null,
      customersList:[],
      selectedCustomer:null,
      end:null,
      start:null,
      pendingValidationOrdersListkey:0,
    };
  }, 
  methods:{
    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
        response => {
          this.customersList=response;
        }
      )
    },


  },
    watch: {
      selectedCustomer:function(){
        this.pendingValidationOrdersListkey++
      },

      end:function(){
        this.pendingValidationOrdersListkey++
      },

      start:function(){
        this.pendingValidationOrdersListkey++
      }
    }       
    }

</script>
<style>

.style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>
<template>
    <div>
      <div  class="row mt-4">
          <div v-if="role==1"  class="col-md-3 col-xs-12 pr-md-4 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
          </div>

          <div class="col-md-2 col-xs-12 pr-md-4">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                  v-model="start"
                  :locale="$t('datPicker.locale')"
                  :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                  dark
                  reset-button
                  close-button
                  :label-reset-button="$t('datPicker.label-reset-button')"
                  :label-close-button="$t('datPicker.label-close-button')"
                  dropright
                  hide-header>
                </b-form-datepicker>
            </b-form-group>
          </div>

          <div class="col-md-2 col-xs-12 pr-md-4">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')" label-for="">
                <b-form-datepicker
                  v-model="end"
                  :locale="$t('datPicker.locale')"
                  :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                  dark
                  reset-button
                  close-button
                  :label-reset-button="$t('datPicker.label-reset-button')"
                  :label-close-button="$t('datPicker.label-close-button')"
                  dropright                         
                  hide-header>
                </b-form-datepicker>
            </b-form-group>
          </div>


      </div>
      <PendingValidationOrdersList :key="pendingValidationOrdersListkey" :start=start :end=end :customerId="this.selectedCustomer ? this.selectedCustomer.id : null" />
    </div>
</template>
